import { useCallback, useState } from "react";
import { startRegistration } from "@simplewebauthn/browser";
import { useAuth } from "providers/AuthProvider";

export const useRegisterPasskey = () => {
  const { token } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const registerPasskey = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch( `${process.env.REACT_APP_BACKEND_URL}/auth/passkey/register/options`, { method: "POST", headers: { Authorization: `Bearer ${token}` } } );
      const options = await response.json();
      if (!response.ok) throw new Error(options.message);
      const { challengeId, ...registrationOptions } = options;
      const credential = await startRegistration({ optionsJSON: registrationOptions });
      const verifyResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/passkey/register/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({ credential, challengeId })
        }
      );
      const result = await verifyResponse.json();
      if (!verifyResponse.ok) throw new Error(result.message);
      return result;
    } catch (err) {
      console.error("Device registration failed:", err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  return {
    registerPasskey,
    isLoading,
  };
};